import * as React from 'react';
import { Icon } from 'rsuite';
import styled from 'styled-components';

const TileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  position: relative;

  @media (min-width: 768px) {
    flex-direction: row;
    text-align: left;
    max-width: none;
    flex: 1;
  }
`;

const IconWrapper = styled.div<{ color: 'green' | 'yellow' | 'blue' }>`
  width: 56px;
  height: 56px;
  border-radius: 14px;
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  @media (min-width: 768px) {
    margin-bottom: 0;
    margin-right: 24px;
    flex-shrink: 0;
  }

  ${({ color }) => {
    switch (color) {
      case 'green':
        return `
          background: rgba(15, 202, 152, 0.1);
          color: #0fca98;
        `;
      case 'yellow':
        return `
          background: rgba(255, 143, 0, 0.1);
          color: #ff8f00;
        `;
      case 'blue':
        return `
          background: rgba(29, 150, 255, 0.1);
          color: #1d96ff;
        `;
    }
  }}
`;

const StyledIcon = styled(Icon)`
  font-size: 28px;
  transform: rotate(-45deg);
`;

const TextWrapper = styled.div`
  flex: 1;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: #1f2937;
  margin: 0 0 6px 0;
`;

const Description = styled.p`
  font-size: 15px;
  font-weight: 300;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
`;

interface Props {
  title: string;
  description: string;
  color: 'blue' | 'green' | 'yellow';
  icon: string;
}

export const SimpleWorkTile: React.FC<Props> = ({ title, description, color, icon }) => {
  return (
    <TileWrapper>
      <IconWrapper color={color}>
        <StyledIcon icon={icon} />
      </IconWrapper>
      <TextWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextWrapper>
    </TileWrapper>
  );
};
